import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { formatUsd } from "@kontextwerk/web-common";

import type { CostSummaryBucket } from "../lib/types";

interface Props {
  buckets: CostSummaryBucket[];
  height?: number;
}

const LAYER_COLOR: Record<string, string> = {
  L1: "#4DD0E1",
  L2: "#14B8A6",
  L3: "#7C5CFF",
  L4: "#F59E0B",
  "<unassigned>": "#94A3B8",
};

export default function LayerPieChart({ buckets, height = 240 }: Props) {
  const data = buckets.map((b) => ({
    name: b.group_key,
    value: b.total_cost_usd,
  }));
  if (data.length === 0 || data.every((d) => d.value === 0)) {
    return (
      <div className="text-sm text-kw-text-faint py-8 text-center">
        Keine Layer-Kosten erfasst.
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={80}
          label={({ name }) => name}
          labelLine={false}
        >
          {data.map((d) => (
            <Cell
              key={d.name}
              fill={LAYER_COLOR[d.name] ?? "#A78BFA"}
            />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: "#141A38",
            border: "1px solid #2A3358",
            fontSize: "12px",
          }}
          formatter={(value: number) => formatUsd(value)}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
